import {
  changeOrderUrl,
  notRefViewEditOrderUrl,
  viewEditOrderUrl
} from "@saleor/changeOrder/urls";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

export enum DomesticOrderListSortField {
  piNo = "piNo",
  poNo = "poNo",
  contractNo = "contractNo",
  soldtoParty = "soldtoParty",
  createDate = "createDate"
}

export enum ChangeOrderSortField {
  material_code = "material_code"
}

export interface OrderListUrlAdditional {
  filtered: boolean;
}

export type ExporOrderListUrlSort = Sort<DomesticOrderListSortField>;
export type ExporOrderListUrlQueryParams = Pagination &
  ExporOrderListUrlSort &
  OrderListUrlAdditional;

export const DomesticOrderListUrl = (params?: ExporOrderListUrlQueryParams) =>
  changeOrderUrl + "?" + stringifyQs(params);

export const changeOrderPath = (id: string) =>
  urlJoin(viewEditOrderUrl, id || "");
export const changeOrderPathUrl = (id: string, params?: any) =>
  changeOrderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const notRefchangeOrderPath = (id: string) =>
  urlJoin(notRefViewEditOrderUrl, id || "");
export const notRefChangeOrderPathUrl = (id: string, params?: any) =>
  notRefchangeOrderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export interface OrderProcessingParams {
  callback?: string;
}

export const orderProcessing = `${changeOrderUrl}/order-processing`;
export const orderProcessingParamUrl = (params?: OrderProcessingParams) =>
  orderProcessing + "?" + stringifyQs(params);
